// [ai] window.__dossier — the E2E seam scripts/e2e/lib.py reads (state over pixels). dump() is a plain JSON snapshot (the shell's
// fields + the player's, the old dossier.js keys); side.set() drives the sidebar; open/close/player/engine drive the player; astra is the chat controller;
// pages.<name> = a mounted page's own seam (app/pageSeam.ts) and dump().<name> its state.
import type { StoreApi } from "zustand";
import type { ShellState } from "../stores/shell";
import type { Link } from "../core/links";
import type { Engine } from "../media/engine";
import type { Player } from "../player/player";
import type { Importer } from "../imports/importer";
import type { Astra } from "../chat/astra";
import type { Widgets } from "../widgets/widgets";
import { pages, pageDumps } from "./pageSeam";

export type ShellDump = { page: string; route: string; side: ShellState["side"]; barH: number; sse: ShellState["sse"]; crumb: string; chrome: string };
export type Seam = { store: StoreApi<ShellState>; side: { set: (open: boolean) => void }; player: Player; engine: Engine; open: (link: Link, opts?: { play?: boolean }) => Promise<void>; close: () => void; dump: () => ShellDump & ReturnType<Player["dump"]> & { import: ReturnType<Importer["dump"]>; astra: ReturnType<Astra["dump"]>; widgets: ReturnType<Widgets["dump"]> } & Record<string, unknown>; pages: typeof pages; importer: Importer; astra: Astra; widgets: Widgets };
type IO = { pathname: () => string; route: () => string; chrome: () => string };

declare global { interface Window { __dossier?: Seam } }

export function installSeam(store: StoreApi<ShellState>, player: Player, importer: Importer, astra: Astra, widgets: Widgets, io: IO): Seam {
  const seam: Seam = {
    store,
    side: { set: open => store.getState().setSide(open) },
    player, importer, astra, widgets, pages, engine: player.engine, open: (link, opts) => player.open(link, opts), close: () => player.close(),
    dump: () => { const s = store.getState(); return { page: io.pathname(), route: io.route(), side: { ...s.side }, barH: s.barH, sse: { ...s.sse }, crumb: s.crumb, chrome: io.chrome(), ...player.dump(), import: importer.dump(), astra: astra.dump(), widgets: widgets.dump(), ...pageDumps() }; },
  };
  window.__dossier = seam; return seam;
}
